<template>
    <div class="switch-big" @click="switchToggle()"  :class="[{right:switchMode==local.config.right.value,left:switchMode==local.config.left.value},propsClass]">
         <div class="switch-big-btn backgroundOrange" ></div>
         <span class="right-option" :class="{active:switchMode==local.config.right.value}" >{{local.config.right.text}}</span>
         <span class="left-option" :class="{active:switchMode==local.config.left.value}" >{{local.config.left.text}}</span>
    </div>
</template>

<script>
export default {
    props:['default','config','propsClass'], 
    data(){
        return {
            switchMode:this.default,
            local:{config:this.config}
        }
    },
    components: {
  
    },
    watch: {
        default:function(val){
            this.switchMode=val
        },
        config:function(val){
            this.local.config=val
        },
        switchMode:function(val){
            if(val==this.local.config.right.value){
                this.$emit('switch',this.local.config.right.value)
            }else{
                this.$emit('switch',this.local.config.left.value)
            }
        }
    },
    methods:{
        switchToggle(){
            if(this.switchMode==this.local.config.right.value){
                this.switchMode=this.local.config.left.value
            }else{
                this.switchMode=this.local.config.right.value
            }
        }
    }
}
</script>

<style>
.switch-big {

    width: calc(50% - 16px);
    height: 40px;
    border-radius: 80px;
    background: rgba(0, 0, 0, 0.04);
    -webkit-box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.04);
    box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.04);
    margin-right: 8px;
    float: right;
    cursor: pointer;

}
.switch-big-btn {

    width: calc(50% - 8px);
    height: 32px;
    border-radius: 20px;
    -webkit-box-shadow: 0px 3px 6px rgba(255, 137, 51, 0.5);
    box-shadow: 0px 3px 6px rgba(255, 137, 51, 0.5);
    margin: 4px;

}
.right .switch-big-btn{
    margin-right: calc(4px);
    transition: all .3s ease-in-out
}
.left .switch-big-btn{
    margin-right: calc(50% + 4px);
    transition: all .3s ease-in-out;
}
.switch-big .right-option {

    margin: -30px 60px 0 0;

}
.switch-big .left-option {

    margin: -30px 220px 0 0;

}

.Switch-big.left{
        animation-delay:0.1s;
        -webkit-transition: all 0.1s;
        -webkit-transition-timing-function: linear;
        transition: all 0.1s;
        transition-timing-function: linear;
}
.filterHeadLeft .switch-big{
    float: left;
    margin-right: 0;
}
@media (max-width: 768px){
    .switch-big .right-option{
        margin: -30px calc(25% - 20px) 0 0;
    }
    .switch-big .left-option{
        margin: -30px calc(75% - 40px) 0 0;
    }
    .switch-big{
    width: calc(100% - 16px);
    }
}

</style>
